var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('carousel-slide'),_c('carousel-slide-footer'),_c('company-vision'),_c('company-stats'),_c('what-we-do'),_c('happy-clients')],1)}
var staticRenderFns = []

export { render, staticRenderFns }